import Image, { ImageProps } from "next/image";
import React from "react";

const isAemUrl = (src: ImageProps["src"]): src is string => {
  if (typeof src !== "string") return false;
  try {
    const url = new URL(src);
    return url.hostname.includes("aem") || url.hostname.includes("adobe");
  } catch {
    return false;
  }
};

const isExternalUrl = (src: ImageProps["src"]): src is string => {
  return typeof src === "string" && /^https?:\/\//.test(src);
};

function fixImageUrl(url: string) {
  return url.replace(/([^:]\/)\/+/g, "$1");
}

const ImageWrapper: React.FC<ImageProps> = (props) => {
  const { src, alt = "", optimize=false, ...rest } = props;
  const shouldUnoptimize = isExternalUrl(src) && !isAemUrl(src) || optimize;
  const imagesrc =
    !shouldUnoptimize && typeof src === "string" ? fixImageUrl(src) : src;

  return (
    <Image src={imagesrc} alt={alt} {...rest} unoptimized={shouldUnoptimize} />
  );
};

export default ImageWrapper;
